// src/app/core/pwa/services/pwa-demo.service.ts

import { Injectable } from '@angular/core';
import { PwaService } from './pwa.service';
import { PwaTriggerService } from './pwa-trigger.service';

@Injectable({
  providedIn: 'root'
})
export class PwaDemoService {

  constructor(
    private pwaService: PwaService,
    private pwaTriggerService: PwaTriggerService
  ) {}

  /**
   * Força a exibição do popup para demonstração
   */
  showDemoPrompt(): void {
    console.log('PWA Demo: Forcing prompt display');
    this.pwaService.showPromptUI();
  }

  /**
   * Simula login do usuário para testes
   */
  simulateUserLogin(): void {
    console.log('PWA Demo: Simulating user login');
    this.pwaTriggerService.setUserLoggedIn(true);
  }

  /**
   * Força verificação das condições de trigger
   */
  forceCheck(): void {
    console.log('PWA Demo: Forcing trigger check');
    this.pwaTriggerService.forceCheck();
  }

  /**
   * Reseta todas as preferências para testes
   */
  resetForTesting(): void {
    console.log('PWA Demo: Resetting preferences');
    this.pwaService.resetPreferences();
    this.pwaTriggerService.resetSession();
  }

  /**
   * Obtém estatísticas para debug
   */
  getDebugInfo(): any {
    const sessionStats = this.pwaTriggerService.getSessionStats();
    
    return {
      session: sessionStats,
      canShowPrompt: this.pwaService.canShowPrompt(),
      isStandalone: this.pwaService.isRunningStandalone(),
      timestamp: new Date().toISOString()
    };
  }

  /**
   * Adiciona métodos de debug ao console global (apenas em desenvolvimento)
   */
  enableDebugMode(): void {
    if (typeof window !== 'undefined') {
      (window as any).pwaDebug = {
        show: () => this.showDemoPrompt(),
        login: () => this.simulateUserLogin(),
        check: () => this.forceCheck(),
        reset: () => this.resetForTesting(),
        info: () => this.getDebugInfo(),
        help: () => {
          console.log(`
PWA Debug Commands:
- pwaDebug.show()  : Force show popup
- pwaDebug.login() : Simulate user login
- pwaDebug.check() : Force trigger check
- pwaDebug.reset() : Reset preferences
- pwaDebug.info()  : Get debug info
- pwaDebug.help()  : Show this help
          `);
        }
      };
      
      console.log('PWA Debug mode enabled. Type "pwaDebug.help()" for commands.');
    }
  }
}
